import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { Shipping } from '../models/shipping';

export class ShippingMapper extends BaseMapper<Shipping> {
   
}
